import { PhoneContainer, Phone } from './styled'

import phoneImg from '../images/Phone.svg'
const PhoneNumbers = () => {
  return (
    <PhoneContainer>
      <Phone>
        <img src={phoneImg} alt="phone" />В Центр социального обслуживания
        "Инсон" или к социальным работникам по телефону 1140.
      </Phone>
      <Phone>
        <img src={phoneImg} alt="phone" />
        Позвонить в дежурную часть полиции по номеру 102 или к инспекторам
        профилактики.
      </Phone>
      <Phone>
        <img src={phoneImg} alt="phone" />
        Обратиться в единую диспетчерскую службу по номеру 112 или на телефон
        доверия 1146.
      </Phone>
      <Phone>
        <img src={phoneImg} alt="phone" />
        Позвонить на горячую линию по борьбе с насилием против женщин: 1259.
      </Phone>
      <Phone>
        <img src={phoneImg} alt="phone" />
        Связаться с Центром реабилитации и адаптации жертв насилия +998 71 207
        40 77
      </Phone>
    </PhoneContainer>
  )
}

export default PhoneNumbers
